import { useState, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import './SearchBar.css'

function SearchBar({ placeholder = "Rechercher...", value, onChange, onClear, globalSearch = false, onKeyDown: customOnKeyDown }) {
  const searchInputRef = useRef(null)
  const searchContainerRef = useRef(null)
  const glassSearchRef = useRef(null)
  const [isExpanded, setIsExpanded] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    const glassElements = glassSearchRef.current ? [glassSearchRef.current] : []
    
    const handleMouseMove = (e) => {
      const rect = e.currentTarget.getBoundingClientRect()
      const x = e.clientX - rect.left
      const y = e.clientY - rect.top
      
      const specular = e.currentTarget.querySelector('.glass-specular')
      if (specular) {
        specular.style.background = `radial-gradient(
          circle at ${x}px ${y}px,
          rgba(255,255,255,0.15) 0%,
          rgba(255,255,255,0.05) 30%,
          rgba(255,255,255,0) 60%
        )`
      }
    }
    
    const handleMouseLeave = (e) => {
      const specular = e.currentTarget.querySelector('.glass-specular')
      if (specular) {
        specular.style.background = 'none'
      }
    }
    
    glassElements.forEach(element => {
      element.addEventListener('mousemove', handleMouseMove)
      element.addEventListener('mouseleave', handleMouseLeave)
    })
    
    return () => {
      glassElements.forEach(element => {
        element.removeEventListener('mousemove', handleMouseMove)
        element.removeEventListener('mouseleave', handleMouseLeave)
      })
    }
  }, [])

  const handleFocus = () => {
    setIsExpanded(true)
  }

  const handleBlur = () => {
    setIsExpanded(false)
  }

  const handleClear = () => {
    if (onChange) {
      onChange({ target: { value: '' } })
    }
    if (onClear) {
      onClear()
    }
    if (searchInputRef.current) {
      searchInputRef.current.focus()
    }
  }

  const handleKeyDown = (e) => {
    if (customOnKeyDown) {
      customOnKeyDown(e)
      return
    }
    if (e.key === 'Enter' && globalSearch && value && value.trim()) {
      e.preventDefault()
      navigate(`/search?q=${encodeURIComponent(value.trim())}`)
    }
  }

  return (
    <div className="glass-search" ref={glassSearchRef}>
      <div className="glass-filter"></div>
      <div className="glass-overlay"></div>
      <div className="glass-specular"></div>
      <div className="glass-content">
        <div className={`search-container ${isExpanded ? 'expanded' : ''}`} ref={searchContainerRef}>
          <i className="fas fa-search search-icon"></i>
          <input
            ref={searchInputRef}
            type="search"
            inputMode="search"
            enterKeyHint="search"
            autoComplete="off"
            placeholder={placeholder}
            className="search-input"
            value={value || ''}
            onChange={onChange}
            onFocus={handleFocus}
            onBlur={handleBlur}
            onKeyDown={handleKeyDown}
          />
          <button 
            className={`search-clear ${value && value.length > 0 ? 'show' : ''}`}
            onClick={handleClear}
            aria-label="Clear search"
          >
            <i className="fas fa-times"></i>
          </button>
        </div>
      </div>
    </div>
  )
}

export default SearchBar

